// extracted by mini-css-extract-plugin
export default {"menuBlock":"SL-z","title":"TL-z","nav":"UL-z","flexCell":"VL-z","facetLink":"WL-z"};